
export default{
    thumb: 'Thumb',
    name: 'Name',
    description: 'Description',
    action: 'Action',
    noImage: 'No Image',
    noFile: 'No File',
    addAFile: 'Add A File',
}